import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import PeopleInput from "./PeopleInput/index";
import SessionSelection from "./SessionSelection/index";
import MyCalendar from "../../components/Calendar/index";
import "./BookingPage.css";
import {
  setDate,
  setSession,
  setPeople,
  setPickupPoint,
} from "./carAvailability/carAvailabilitySlice";
import BookingForm from "./booking/BookingForm/index";
import { fetchBlackoutDates } from "../dashboard/ManageBookings/Blackout/BlackoutSlice"; // Adjust the path as necessary
import { verifyAvailability } from "./verifyAvailability/verifyAvailabilityThunk";
import { resetCarAvailabilityState } from "./carAvailability/carAvailabilitySlice";
import { resetBookingState } from "./booking/bookingsSlice";
import PickupPointSelect from "./booking/PickupPoint";

function BookingPage() {
  const dispatch = useDispatch();
  const people = useSelector((state) => state.carAvailability.people);
  const pickupPoint = useSelector((state) => state.carAvailability.pickupPoint); // Get the pickup point from Redux

  const fetchWithRetry = useCallback(
    async (attempt = 1) => {
      try {
        await dispatch(fetchBlackoutDates());
      } catch (error) {
        if (attempt < 3) {
          console.error(`Attempt ${attempt} failed. Retrying...`);
          fetchWithRetry(attempt + 1);
        } else {
          console.error("Failed to fetch after 3 attempts.", error);
        }
      }
    },
    [dispatch]
  );
  useEffect(() => {
    // Reset the state when the component mounts
    dispatch(resetCarAvailabilityState());
    dispatch(resetBookingState());
    fetchWithRetry();
  }, [dispatch, fetchWithRetry]);

  const [availabilitySuccess, setAvailabilitySuccess] = useState(false);
  const [inputsDisabled, setInputsDisabled] = useState(false); // New state

  const handleDateChange = (date) => {
    dispatch(setDate(date));
  };

  const handleSessionChange = (session) => {
    dispatch(setSession(session));
  };

  const handlePeopleChange = (people) => {
    dispatch(setPeople(people));
  };

  const handlePickupPointChange = (point) => {
    dispatch(setPickupPoint(point)); // Dispatch the pickup point to Redux
  };

  const handleBooking = () => {
    if (!people || people <= 0) {
      alert("Please enter the number of people.");
      return;
    }

    if (!pickupPoint) {
      alert("Please select a pickup point.");
      return;
    }

    dispatch(verifyAvailability())
      .unwrap()
      .then((result) => {
        if (result.status === "available") {
          setAvailabilitySuccess(true);
          setInputsDisabled(true);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(error.message); // This will inform the user which session(s) don't have enough space
      });
  };

  const blackoutDates = useSelector((state) => state.blackoutDates);

  return (
    <div>
      <div className="calendar-container">
        <MyCalendar
          onDateChange={handleDateChange}
          blackoutDates={blackoutDates}
        />
      </div>
      <div className="booking-controls">
        <SessionSelection
          onSessionChange={handleSessionChange}
          disabled={inputsDisabled}
        />
        <PeopleInput
          onPeopleChange={handlePeopleChange}
          disabled={inputsDisabled}
        />
        <PickupPointSelect
          onPickupPointChange={handlePickupPointChange} // Pass the handler here
          disabled={inputsDisabled}
        />
        <button className="modern-btn" onClick={handleBooking}>
          Submit
        </button>
      </div>
      {availabilitySuccess && <BookingForm pickupPoint={pickupPoint} />}
    </div>
  );
}
export default BookingPage;
// testing out firebase deployment
